import { Modal } from "@mui/material";
import Styles from "./SelectParticipant.module.css";
import React, { useMemo, useState } from "react";
import { Close, Delete } from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { handleRemoveUser_api } from "../../../../Services/ReverseAuction/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";

const ICON_STYLE = { fontSize: "14px" };

const SelectParticipant = ({
  open,
  handleClose,
  list,
  selected,
  header,
  handleSelectList,
  type,
  editType,
  tenderId,
  participants,
  handleRemoveParticipant,
  editClosed,
}) => {
  const [search, setSearch] = useState("");

  const filteredList = useMemo(() => {
    if (!search) return list || [];
    return (list || []).filter((item) =>
      (item.generatorName?.toLowerCase() || "").includes(search.toLowerCase()),
    );
  }, [list, search]);

  const isViewMode = type === "view";

  const participantName = (id) =>
    (list || []).find((item) => item?.id === id)?.generatorName;

  const isSelected = (id) =>
    editType ? editClosed?.includes(id) : selected?.includes(id);

  const otherGenerators = filteredList.filter(
    (item) => !participants?.includes(item?.id),
  );

  const handleRemoveUser = async (genId) => {
    const res = await handleRemoveUser_api({ tenderId, genId });
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleRemoveParticipant(genId);
    } else {
      ErrorMessage(res?.data?.error || res?.data?.message);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.selectionModal}`}>
        <div className={`display_flex_row modalHeading ${Styles.modalHeading}`}>
          <div className="headingText">{header}</div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>

        {!isViewMode && (
          <div className={Styles.searchMain}>
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        )}

        <div className={Styles.displayMainElem}>
          <div
            className={`display_flex_row tableHeading ${Styles.tableMainElem}`}
          >
            <div className="table_text_align_left">S.No.</div>
            <div className="table_text_align_left">Seller Name</div>
          </div>

          <div className={`scroll_bar_y ${Styles.detailsMainElem}`}>
            {participants?.map((id, index) => (
              <div
                key={id}
                className={`display_flex_row tableDetails ${Styles.tableMainDetails}`}
              >
                <div className="display_flex_row_gap_8_only">
                  <Delete
                    style={{ ...ICON_STYLE, color: "red" }}
                    onClick={() => handleRemoveUser(id)}
                  />
                  <div>{index + 1}</div>
                </div>
                <div className="table_text_align_left">
                  {participantName(id)}
                </div>
              </div>
            ))}

            <div className={Styles.otherGenerator}>Others Generators</div>

            {otherGenerators.map((item, index) => (
              <div
                key={item?.id}
                className={`display_flex_row tableDetails ${Styles.tableMainDetails}`}
                onClick={() => handleSelectList(item?.id)}
              >
                <div className="display_flex_row_gap_8_only">
                  {!isViewMode &&
                    (isSelected(item?.id) ? (
                      <CheckBoxIcon style={ICON_STYLE} />
                    ) : (
                      <CheckBoxOutlineBlankIcon style={ICON_STYLE} />
                    ))}
                  <div>{index + 1}</div>
                </div>
                <div className="table_text_align_left">
                  {item?.generatorName || item?.name}
                </div>
              </div>
            ))}
          </div>
        </div>

        {!isViewMode && (
          <div className={`display_flex_row_gap_8 ${Styles.buttonMain}`}>
            <div className="activeButton_type_3" onClick={handleClose}>
              Cancel
            </div>
            <div className="activeButton" onClick={handleClose}>
              Done
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SelectParticipant;
